import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { forwardRef, useMemo, useState, useEffect, useCallback } from 'react';
import cns from '../../node_modules/classnames/index.js';
import Spinner from '../Spinner/Spinner.js';
import PopOver from '../PopOver/PopOver.js';
import useForwardRefOrRef from '../Hooks/useForwardRefOrRef.js';

/**
 * Bottone
 */
const Button = forwardRef((_a, ref) => {
    var { children, className, flat, floating, icon, primary, text, big, disabled, loading, selected, tooltip, onClick } = _a, others = __rest(_a, ["children", "className", "flat", "floating", "icon", "primary", "text", "big", "disabled", "loading", "selected", "tooltip", "onClick"]);
    const classes = useMemo(() => cns('button', {
        'button--primary': primary,
        'button--text': text,
        'button--flat': flat,
        'button--floating': floating,
        'button--big': big,
        'button--icon': icon,
        'button--standard': !flat && !floating && !icon,
        selected,
    }, className), [big, className, flat, floating, icon, primary, selected, text]);
    const [buttonRef, myRef] = useForwardRefOrRef(ref);
    const [disabledInternal, setDisabled] = useState(disabled);
    const [running, setRunning] = useState(loading);
    useEffect(() => setDisabled(disabled), [disabled]);
    useEffect(() => setRunning(loading), [loading]);
    const onClickInternal = useCallback((e) => {
        if (disabledInternal || running || !onClick) {
            return;
        }
        myRef.current.blur();
        const res = onClick(e);
        if (res && (res.always || res.then)) {
            setDisabled(true);
            setRunning(true);
            if (res.always) {
                res.always(() => {
                    setDisabled(false);
                    setRunning(false);
                });
            }
            else {
                res.then(() => {
                    setDisabled(false);
                    setRunning(false);
                });
            }
        }
    }, [disabledInternal, running, onClick, myRef]);
    return ((floating || icon) && tooltip
        ? (jsx(PopOver, { content: tooltip, children: jsxs("button", Object.assign({}, others, { className: classes, disabled: disabledInternal, onClick: onClickInternal, ref: buttonRef, type: "button", children: [children, running && jsx("span", { className: "button__loader", children: jsx(Spinner, { small: true }) })] })) }))
        : (jsxs("button", Object.assign({}, others, { className: classes, disabled: disabledInternal, onClick: onClickInternal, ref: buttonRef, type: "button", children: [children, running && jsx("span", { className: "button__loader", children: jsx(Spinner, { small: true }) })] }))));
});
Button.defaultProps = {
    big: false,
    children: null,
    className: '',
    disabled: false,
    flat: false,
    floating: false,
    icon: false,
    loading: false,
    onClick: undefined,
    primary: false,
    selected: false,
    text: false,
    tooltip: '',
};

export { Button as default };
